import React from 'react';
import ReactMarkdown from 'react-markdown';

import { useTariffToolCheck } from '../../hooks/useTariffToolCheck';
import { useGetConsultationAbstractQuery } from '../../services/consultation-results.api';

import { AiAssistantDisclaimer } from './ai-assistant-disclaimer';
import { AiAssistantMissingMessage } from './ai-assistant-missing-message';

type Props = {
  consultationId?: number;
  isGroupConsultation?: boolean;
};

export const AiAbstractTab = ({ consultationId, isGroupConsultation = false }: Props) => {
  const hasConsultationId = Boolean(consultationId);
  const { data, isFetching, isLoading, isError } = useGetConsultationAbstractQuery(
    consultationId ? consultationId.toString() : '',
    { skip: !hasConsultationId },
  );

  const renderCard = (children: React.ReactNode, variant: 'default' | 'error' = 'default') => {
    const baseClasses = 'p-1 lg:p-1 text-body-l lg:text-body-xl leading-relaxed space-y-4';
    const variantClasses = variant === 'error' ? 'text-primary' : 'text-ink-muted';

    return (
      <div className={`${baseClasses} ${variantClasses}`}>
        <div className="flex items-center gap-3 text-ink"></div>
        {children}
      </div>
    );
  };

  const hasSupervisorTool = useTariffToolCheck('ai_supervisor');

  if (!hasConsultationId) {
    return renderCard(<>Выберите запись, чтобы увидеть ИИ-конспект.</>);
  }

  if (isLoading || isFetching) {
    return renderCard(<p>Загружаем ИИ-конспект...</p>);
  }

  const showTariffLine = !hasSupervisorTool;

  if (isError) {
    return renderCard(
      <AiAssistantMissingMessage
        assistant="ai-abstract"
        showTariffLine={showTariffLine}
        isGroupConsultation={isGroupConsultation}
      />,
      'error',
    );
  }

  if (!data?.abstract) {
    return renderCard(
      <AiAssistantMissingMessage
        assistant="ai-abstract"
        showTariffLine={showTariffLine}
        isGroupConsultation={isGroupConsultation}
      />,
    );
  }

  return renderCard(
    <div className="text-ink text-ui lg:text-body-l leading-relaxed">
      <ReactMarkdown
        components={{
          p: (paragraphProps) => <p className="mt-3 mb-1 last:mb-0" {...paragraphProps} />,
        }}
      >
        {data.abstract}
      </ReactMarkdown>
      <AiAssistantDisclaimer assistant="ai-abstract" />
    </div>,
  );
};
